module.exports = __webpack_public_path__ + "img/ic_audio.0ff6aaa5.png";